import React from 'react';
import { NostoTagging } from './Provider';
const NostoCategory = ({ promise, data }) => (React.createElement(NostoTagging, { id: "category", promise: promise, data: data }, data => {
    const { category, categories, tags } = data;
    return (React.createElement("div", { style: { display: 'none' } },
        React.createElement("div", { className: "nosto_page_type" }, "category"),
        React.createElement("div", { className: "nosto_category" }, category ||
            categories.map((c) => (React.createElement("span", { className: "category", key: c }, c)))),
        tags &&
            tags.map((tag) => (React.createElement("span", { className: "nosto_tag", key: tag }, tag)))));
}));
export default NostoCategory;
//# sourceMappingURL=Category.js.map